import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import "./TopBar.css";
import HamburgerArea from "../../../controls/HamburgerArea/HamburgerArea.mjs";
import UserIcon from "../../../media/images/UserIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import LockOffIcon from "../../../media/images/LockOffIcon.mjs";
import LanguageSwitcher from "../../../controls/LanguageSwitcher/LanguageSwitcher.mjs";
import AppAdminIcon from "../../../media/app-images/AppAdminIcon.mjs";
import ChevronDownIcon from "../../../media/images/ChevronDownIcon.mjs";
import AboutModal from "../AboutModal.mjs";
import AppMainIcon from "../../../media/app-images/AppMainIcon.mjs";
import ChevronRightIcon from "../../../media/images/ChevronRightIcon.mjs";

const prefix = "TopBar";

const TopBar = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: Glob.getStatus('userLogin'),
			pageTitle: Glob.getStatus('pageTitle'),
			lang: Glob.getLanguage(),
			pageIcon: Glob.getStatus('pageIcon'),
			slider: Glob.getStatus('slider')
		}
		this.uid = Glob.generateUid(prefix);
		this.updatePageTitle = this.updatePageTitle.bind(this);
	}
	componentDidMount() {
		Glob.register('userLogin', ul => {
			this.setState({user: ul});
		}, this.uid);
		Glob.register('pageTitle', pt => {
			this.setState({pageTitle: pt}, this.updatePageTitle );
		}, this.uid);
		Glob.register('pageIcon', i => {
			this.setState({pageIcon: i });
		}, this.uid);
		Glob.register('Prefs', p => {
			this.setState({lang: p.lang}, this.updatePageTitle);
		}, this.uid);
		Glob.register('slider', s => {
			this.setState({slider: s });
		}, this.uid);
		this.updatePageTitle();
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	updatePageTitle() {
		const pt = this.state.pageTitle ? (
			typeof this.state.pageTitle === "string" ?
				Glob.label(this.state.pageTitle) :
				(
					(Array.isArray(this.state.pageTitle) && this.state.pageTitle.length ) ?
					this.state.pageTitle.map( l => Glob.label(l) ).join(' :: ') : ''
				)
		) : "";
		let wt = window.document.title.replace(/ :: .+/,'');
		if ( pt ) wt += ' :: '+pt;
		window.document.title = wt;
	}
	render() {
		if ( ! this.state.user ) return null;
		return(
			<div className={prefix} id={this.uid}>
				<div className={"icon-area"}>
					<div className={"slider-switch"}>
						<div
							className={"switch-"+( this.state.slider ? 'on' : 'off')}
							onClick={ ()=>{
								Glob.setStatus('slider', ! this.state.slider );
							}}
						>
							<ChevronDownIcon />
						</div>
					</div>
					<div className={"page-icon"}>
						{this.state.pageIcon || null }
					</div>
				</div>
				<div className="pageTitle">
					{ typeof this.state.pageTitle === "string" ? (
						<div>
							<span>
								<TextLabel value={this.state.pageTitle || ''} />
							</span>
						</div>
					) : (
						(Array.isArray(this.state.pageTitle) && this.state.pageTitle.length) ? (
							this.state.pageTitle.map((item, i) => (
								<div key={i}>
									{ i !== 0 && <ChevronRightIcon /> }
									<span><TextLabel value={item} /></span>
								</div>
							))
						) : ''
					)}
				</div>
				<div className={"userMenu"}>
					<HamburgerArea
						icon={<UserIcon />}
						align={"end"}
					>
						<div className={"userMenu"}>
							<LanguageSwitcher />
							<hr/>
							<button
								disabled={true}
								type={"button"}
							>
								<span key={this.state.user?.username||'anonymous'}>
									{ this.state.user.username.includes('@') ? (
										<b title={this.state.user.username}>
											{ this.state.user.username.replace(/@.*/,'') }
										</b>
									) : (
										<b>
											{ this.state.user.username }
										</b>
									) }
								</span>
								{ appLib.admin() ? <AppAdminIcon /> : <UserIcon /> }
							</button>
							<button
								type={"button"}
								onClick={() => appLib.logout()}
							>
								<span>
									<b>
										<TextLabel value={"Logout"} />
									</b>
								</span>
								<LockOffIcon />
							</button>
							<hr />
							<button
								type={"button"}
								onClick={() => { this.setState({about:true})}}
								>
								<span>
									<b>
										<TextLabel value={"About"} />…
									</b>
								</span>
								<AppMainIcon />
							</button>
						</div>
					</HamburgerArea>
				</div>
				{ this.state.about && (
					<AboutModal
						close={ ()=>{ this.setState({about:false}) }}
					/>
				)}
			</div>
		)
	}
}

export default TopBar;
